import React, { useEffect, useState } from "react";
import { filesize } from "filesize";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { uploadToS3 } from "../../api/apiService";
import {
  FaCloudUploadAlt,
  FaCheckCircle,
  FaSpinner,
  FaTimesCircle,
  FaTimes,
  FaPaste,
} from "react-icons/fa";
import {
  useSelector,
  useDispatch,
  useLocation,
  useNavigate,
} from "../../components/hooks/hooks";
import { awsConfig } from "../../config";
import AWS from "aws-sdk";
import { ToastContainer, toast } from "react-toastify";
import { backendApi } from "../../api/apiService";
import { setAwsConfigData } from "../../redux/reducers/masterDataSlice";
import LoaderImage from "../../images/spinner.gif";
export default function ResumeBulkUpload() {
  const dispatch = useDispatch();
  const { awsData, recuitmentStatus } = useSelector(
    (state) => state.commonData
  );
  const [awsConfigDataState, setAwsConfigDataState] = useState(awsConfig);
  // const [applicationStatus, setApplicationStatus] = useState("");
  // const [docLink, setDocLink] = useState("");
  // const [ctc, setCtc] = useState("");
  // const [ectc, setEctc] = useState("");
  // const [locality, setLocality] = useState("");
  // const [preferredLocation, setPreferredLocation] = useState("");
  // const [relocate, setRelocate] = useState("");
  const [skillsArray, setSkillsArray] = useState([]);
  // const [resumeText, setResumeText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [processedFiles, setProcessedFiles] = useState([]);
  const [resumeSource, setResumeSource] = useState("");
  const [unValidFileProcessedFiles, setunValidFileProcessedFiles] = useState(
    []
  );
  const [flag, setFlag] = useState(false);
  var s3;
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("ResumeBulkUploadMenu").classList.add("active");
    }, 500);
  }, []);
  // const handleFileUpload = async (e) => {
  //     setSelectedFiles([])
  //     setProcessedFiles([])
  //     setFlag(false)
  //     const files = e.target.files;
  //     const allowedFileTypes = [
  //         'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  //         'application/pdf'
  //     ];
  //     const selectedFileLoad = [];
  //     const unValifFormat=[]
  //     for (const file of files) {
  //         if (allowedFileTypes.includes(file.type)) {
  //             //  file.flagFile = "";
  //             selectedFileLoad.push(file);
  //         }
  //         // if (selectedFileLoad.length > 0) {
  //             setSelectedFiles(selectedFileLoad);
  //         // } else
  //         //  {
  //             unValifFormat.push(file)
  //             setunValidFileProcessedFiles(unValifFormat)
  //             // setSelectedFiles([])
  //             toast.warn('Please Choose A Valid Format', { containerId: 'D' });
  //         // }
  //     }

  // };
  const handleFileUpload = (e) => {
    setSelectedFiles([]);
    setProcessedFiles([]);
    setunValidFileProcessedFiles([]);
    setFlag(false);
    const files = e.target.files;
    if (files.length > 100) {
      toast.warn("Only 100 Files Can Be Uploaded At A Time", {
        containerId: "D",
      });
      return;
    }
    const allowedFileTypes = [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
    ];
    const selectedFileLoad = [];
    const unValidFormat = [];

    for (const file of files) {
      if (allowedFileTypes.includes(file.type)) {
        selectedFileLoad.push(file);
      } else {
        unValidFormat.push(file);
      }
    }
    if (selectedFileLoad.length > 0) {
      const substringsToRemove = [
        "Naukri_",
        "Naukri",
        "Linkedin",
        "LinkedIn",
        "Linkedin_",
        "LinkedIn_",
      ];
      const regex = new RegExp(`^(${substringsToRemove.join("|")})`, "i");
      //   const processedData = selectedFileLoad.map((file) => ({
      //     file,
      //     documentName: file.name.replace(regex, ""),
      //   }));

      const updatedSelectedFiles = selectedFileLoad.map((file) => {
        file.documentName = file.name.replace(regex, "");
        return file;
      });
      console.log(
        "🚀 ~ updatedSelectedFiles ~ updatedSelectedFiles:",
        updatedSelectedFiles
      );

      setSelectedFiles(updatedSelectedFiles);
    }
    if (unValidFormat.length > 0) {
      setTimeout(() => {
        setunValidFileProcessedFiles([]);
      }, 4000);
      setunValidFileProcessedFiles(unValidFormat);
      // toast.warn('Please Choose A Valid Format', { containerId: 'D' });
    }
  };

  const uuidv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  const processResumeData = async () => {
    setFlag(true);
    let parsedData;
    const updatedSelectedFiles = selectedFiles.map((file) => {
      file.flagFile = "loading";
      return file;
    });
    setSelectedFiles(updatedSelectedFiles);
    if (selectedFiles) {
      try {
        for (const selectedFile of selectedFiles) {
          // const bucketParams = {
          //   Bucket: awsConfigDataState.s3Bucket,
          // };
          // AWS.config.update({
          //   accessKeyId: "AKIAS3OQS5BMJOLTJSNF",
          //   secretAccessKey: "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",
          //   region: "us-east-1",
          // });
          // const s3 = new AWS.S3({
          //   apiVersion: "2006-03-01",
          //   params: bucketParams,
          // });
          // const data = await s3
          //   .upload({
          //     Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder
          //       }/${uuidv4()}-${selectedFile.documentName}`,
          //     Body: selectedFile,
          //     ACL: "public-read",
          //   })
          //   .promise();

          const data = await uploadToS3(selectedFile);
          await new Promise((resolve) => setTimeout(resolve, 5000));
          const prompt =
            "This is an extract of a resume find the name of the person,address,number,email,skills,total experience,gender if gender or sex is specified and date of birth from this text without code and prefix just in this format   {" +
            '"name":"",' +
            '"address":"",' +
            '"number":"",' +
            '"email":"",' +
            '"skills":["","",""],' +
            '"experience":"",' +
            '"gender":"",' +
            '"dob":""' +
            "} which can be json parsed and dont mind if there are no values for the above mentioned parameters just give me the object which can be json parsed ";

          let apiReq;
          const fileType = data.split(".").pop().toLowerCase();
          if (fileType === "pdf") {
            apiReq = {
              functionName: "pdfDataExtraction",
              file_url: data,
            };
          } else {
            apiReq = {
              functionName: "wordDataExtraction",
              file_url: data,
            };
          }
          // setDocLink(`${data.Location}`)
          const fileData = await backendApi(apiReq);

          if (fileData.success === "1") {
            // setResumeText(fileData.textContent);
            if (fileData.textContent != "\n\n") {
              const req = {
                functionName: "chatGpt_openai",
                prompt: `${fileData.textContent}+${prompt}`,
              };
              const gptData = await backendApi(req);
              if (gptData.success === "1") {
                if (
                  gptData.data.choices[0].message.content
                    .trim()
                    .toLowerCase()
                    .startsWith("answer:")
                ) {
                  const jsonStartIndex =
                    gptData.data.choices[0].message.content.indexOf("{");
                  const jsonString =
                    gptData.data.choices[0].message.content.substring(
                      jsonStartIndex
                    );

                  try {
                    parsedData = JSON.parse(jsonString);
                  } catch (error) {
                    console.error("Error parsing JSON:", error);
                    // toast.warn('Something went wrong! Please try the refresh option', { containerId: 'D' });
                  }
                } else {
                  try {
                    parsedData = JSON.parse(
                      gptData.data.choices[0].message.content
                    );
                  } catch (error) {
                    console.error("Error parsing JSON:", error);
                    failedCondition(selectedFile.name);
                  }
                }
                const saveFormResult = await saveForm(
                  parsedData,
                  selectedFile,
                  data,
                  fileData.textContent
                );
              } else {
                failedCondition(selectedFile.name);
              }
              setLoading(false);
              document.body.classList.remove("overflow-hidden");
            } else {
              setLoading(false);
              failedCondition(selectedFile.name);
              document.body.classList.remove("overflow-hidden");
            }
          }
        }
      } catch (err) {
        console.error("err", err);
        return;
      }
    }
  };
  useEffect(() => {
    if (awsConfigDataState) {
      if (awsData !== "default") dispatch(setAwsConfigData(awsConfigDataState));
      const bucketParams = {
        Bucket: awsConfigDataState.s3Bucket,
      };
      AWS.config.update({
        region: "us-east-1",
      });
      s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: bucketParams,
      });
    }
  }, []);
  const saveForm = async (parsedData, selectedFile, location, textContent) => {
    setProcessedFiles((prevProcessedFiles) => [
      ...prevProcessedFiles,
      selectedFile.name,
    ]);
    let filteredSkills = skillsArray
      .filter((obj) => obj.checked == true)
      .map((obj) => ({
        skill_id: obj.id,
        rating: obj.starValue,
        experience: obj.experience,
      }));
    let noticePeriod = "";
    const apiSave = {
      functionName: "candidateSave",
      site_id: window.localStorage.getItem("siteId"),
      full_name: parsedData.name,
      email_id: parsedData.email,
      mobile_no: parsedData.number,
      sec_contact_no: "",
      total_experiance: parsedData.experience,
      ctc: "",
      ectc: "",
      location: "",
      preferredLocation: "",
      relocate: "",
      notice_period: "",
      remarks: "",
      status: "",
      created_by: localStorage.getItem("userId"),
      address: parsedData.address,
      resume_url: location,
      resume_text: textContent,
      skillSet: parsedData.skills,
      dob: parsedData.dob,
      gender: parsedData.gender,
      source: resumeSource,
    };
    backendApi(apiSave).then((data) => {
      if (data.success === "1") {
        const updatedSelectedFiles = selectedFiles.map((file) => {
          if (file.name === selectedFile.name) {
            file.flagFile = true;
          }
          return file;
        });
        setSelectedFiles(updatedSelectedFiles);
        return data.success;
      } else {
        return selectedFile;
      }
      // toast.success("Saved Successfully", { containerId: "D" });
      // setTimeout(() => {
      //     window.location.reload();
      // }, 2000);
    });
  };
  const removeResume = (data) => {
    const updatedFiles = selectedFiles.filter((file) => file !== data);
    setSelectedFiles(updatedFiles);
  };
  const failedCondition = (selectedFile) => {
    const updatedSelectedFiles = selectedFiles.map((file) => {
      if (file.name === selectedFile) {
        file.flagFile = false;
        // file.Reason = validation;
      }
      return file;
    });

    setSelectedFiles(updatedSelectedFiles);
  };
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"D"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Resume Bulk Upload"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container">
            <div className="xilliWrap">
              {loading && (
                <div className="loader-div">
                  <img src={LoaderImage} alt="Loader" className="loader" />
                </div>
              )}
              {/* <div className="xilliBrudcrb">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <h1>Resume Bulk Upload</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              <div className="card main-card">
                <div className="card-body">
                  <div className="fileUpload  mb-2 mb-md-4">
                    {/* <input type="file" className="default-file-input" > */}
                    <label className="label " style={{ width: "100%" }}>
                      <div className="upload-files-container mb-0">
                        <div className="drag-file-area mb-0">
                          <span className="material-icons-outlined upload-icon">
                            <FaCloudUploadAlt />
                          </span>
                          <h3 className="dynamic-message">
                            {" "}
                            Upload your resume here{" "}
                          </h3>
                          <span className="reBrowse">
                            <label className="label">
                              <span className="browse-files">
                                <input
                                  type="file"
                                  multiple
                                  className="default-file-input"
                                  onChange={(e) => {
                                    handleFileUpload(e);
                                    e.target.value = null;
                                  }}
                                />
                                <span className="browse-files-text">
                                  {" "}
                                  browse file
                                </span>{" "}
                                <span>from device</span>{" "}
                              </span>
                            </label>
                          </span>
                        </div>
                        <span className="cannot-upload-message">
                          {" "}
                          <span className="material-icons-outlined">
                            error
                          </span>{" "}
                          Please select a file first{" "}
                          <span className="material-icons-outlined cancel-alert-button">
                            cancel
                          </span>{" "}
                        </span>
                      </div>
                    </label>
                  </div>
                  {/* <h3 className="sub-head">Source of Resume</h3> */}
                  <div className="row align-items-center mb-2 mb-md-4">
                    <div className="col-md-3 mb-3">
                      <label class="form-label">Source of Resume</label>
                      <input
                        type="text"
                        value={resumeSource}
                        onChange={(e) => setResumeSource(e.target.value)}
                        placeholder="Add source"
                        className="form-control"
                      />
                    </div>


                    <div className="col-md-3 ms-auto">
                      <label class="form-label invisible d-none d-md-block">Total Resume</label>
                      <div class="form-label">Total Resume : {" "}

                        {selectedFiles.length > 0 ||
                          unValidFileProcessedFiles.length > 0 ? selectedFiles?.length : '0'}
                      </div>
                    </div>
                  </div>
                  {selectedFiles.length > 0 ||
                    unValidFileProcessedFiles.length > 0 ? (
                    <div className="bulk-resume-div">
                      {selectedFiles.map((data, index) => {
                        return (
                          <div className="bulk-resume-inner-div" key={index}> <FaPaste color="red" /> {data.documentName}
                            <div>
                              {!processedFiles?.length > 0 && (
                                <FaTimes
                                  onClick={() => removeResume(data)}
                                />
                              )}
                              {data?.flagFile == true && (
                                <span style={{ fontSize: "14px" }}>
                                  <FaCheckCircle color="green" />
                                </span>
                              )}
                              {data?.flagFile == "loading" && flag ? (
                                <span style={{ fontSize: "14px" }}>
                                  <FaSpinner
                                    color="blue"
                                    className="spinner-animation"
                                  />
                                </span>
                              ) : (
                                ""
                              )}
                              {data?.flagFile === false && flag ? (
                                <span style={{ fontSize: "14px" }}>
                                  <FaTimesCircle color="red" />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>


                          </div>
                        )
                      })}
                    </div>
                  ) : ("")}
                  {selectedFiles.length > 0 ||
                    unValidFileProcessedFiles.length > 0 ? (
                    <div className="col-md-12 xilliBrudcrb">
                      {/* <h1 className="main-head py-2">
                        Resume - {selectedFiles?.length}
                      </h1> */}

                      {selectedFiles.length > 0 && (
                        <div className="childIssueses pull-right">
                          {!flag ? (
                            <button
                              type="button"
                              className=" btn-btn btn btn-btn1 me-2"
                              onClick={() => processResumeData()}
                              style={{ fontSize: "14px" }}
                            >
                              {" "}
                              Upload{" "}
                            </button>
                          ) : (
                            ""
                          )}
                          <button
                            type="button"
                            className="btn btn-btn2 btn-btn"
                            onClick={() => {
                              setSelectedFiles([]);
                              setunValidFileProcessedFiles([]);
                            }}
                            style={{ fontSize: "14px" }}
                          >
                            {" "}
                            Reset{" "}
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
